export default __webpack_public_path__ + "static/media/41.7651239f.jpg";